import {fetchBaseQuery} from "@reduxjs/toolkit/dist/query/react";

export function generateBaseQuery(credentials='include') {
    return fetchBaseQuery({
        prepareHeaders: (headers) => {
            headers.append('X-Requested-With', 'XMLHttpRequest');
        },
        credentials
    })
}